
















import Vue from "vue";
import Test from "@/components/generic/UserSelector/AdvancedUserSelector.vue";
import { UserSelectionItem } from "./types";
import { TranslateResult } from "vue-i18n";
import ZenyaDialog, { IZenyaDialog } from "@/components/dialogs/ZenyaDialog.vue";
import { props } from "./types";

/**
 * Defines the methods that can be called on an instance of this component
 */
export interface IUserSelectorDialog extends Vue {
    startAsync(selectedUserItems: UserSelectionItem[]): Promise<UserSelectionItem[]>;
}

export default Vue.extend({
    name: "UserSelectorDialog",
    components: { Test, ZenyaDialog },
    props: {
        /** The options to pass to the user selector */
        ...props
    },
    data: () => {
        return {
            /** Whether to show the dialog */
            show: false as boolean,
            /** The resolver used when closing the dialog to return the result */
            resolveStartAsync: null as (userSelectionItems: UserSelectionItem[]) => void,
            /** The selecteditems of the user selection (model) */
            selectedItems: [] as UserSelectionItem[]
        };
    },
    computed: {
        /** Gets the title of the dialog */
        title(): TranslateResult {
            if (!this.allowedTypes) return "";
            const titles: { user: TranslateResult; usergroup: TranslateResult; team: TranslateResult; none: string; unknown: string } = this.multiple
                ? {
                      user: this.$t("components.userselector.users"),
                      usergroup: this.$t("components.userselector.usergroups"),
                      team: this.$t("components.userselector.teams"),
                      none: null,
                      unknown: null
                  }
                : {
                      user: this.$t("components.userselector.user"),
                      usergroup: this.$t("components.userselector.usergroup"),
                      team: this.$t("components.userselector.team"),
                      none: null,
                      unknown: null
                  };

            if (this.allowedTypes.length == 1) return this.$t("components.userselector.selectOne", { item: titles[this.allowedTypes[0]] });
            if (this.allowedTypes.length == 2)
                return this.$t("components.userselector.selectTwo", {
                    item1: titles[this.allowedTypes[0]],
                    item2: titles[this.allowedTypes[1]]
                });
            if (this.allowedTypes.length == 3)
                return this.$t("components.userselector.selectThree", {
                    item1: titles[this.allowedTypes[0]],
                    item2: titles[this.allowedTypes[1]],
                    item3: titles[this.allowedTypes[2]]
                });

            return this.$t("components.userselector.selectNothing");
        }
    },
    methods: {
        /**
         * Starts the selector dialog
         * @param selectedItems The current selection of items
         * @returns The selected items or null
         */
        async startAsync(selectedItems: UserSelectionItem[]): Promise<UserSelectionItem[]> {
            const dialog: IZenyaDialog = (this.$refs.dialog as unknown) as IZenyaDialog;
            this.selectedItems = selectedItems;
            this.show = true;

            const promise: Promise<UserSelectionItem[]> = new Promise(resolve => {
                this.resolveStartAsync = resolve;
            });

            return promise;
        },
        /** closes the selector and resolves the startAsync promise with item(s) */
        finish(): void {
            this.show = false;
            this.resolveStartAsync(this.selectedItems);
        },
        /** cancel action and close dialog */
        close(): void {
            this.show = false;
            this.resolveStartAsync(null);
        }
    }
});
